import * as React from 'react'

import { FooterView } from './Footer.view'

export const Footer = () => {
  return <FooterView />
}
